module.exports = __webpack_public_path__ + "static/media/pro.d5622e62.png";